export default {
  wsUrl: process.env.REACT_APP_TRACKING_MAP_WS_URL,
};
